
  import { Component, Prop, PropSync, Vue } from "vue-property-decorator";
  import CardRating from "@/components/rating/CardRating.vue";
  import ContractorEmployeeCard from "@/components/companyContractors/ContractorEmployeeCard.vue";
  import { Contractor, Contractor_Rating_Aggregate, User } from "@/generated/graphql";
  import RouteParams from "@/entities/RouteParams";
  import RouteNames from "@/entities/RouteNames";
  import CardItemTitle from "@/components/card/CardItemTitle.vue";
  import ItemChipsWithMore from "@/components/common/ItemChipsWithMore.vue";
  import ManagerChips from "@/components/managers/ManagerChips.vue";
  import CardItemContainer from "@/components/card/CardItemBaseContainer.vue";
  import CardItemValue from "@/components/card/CardItemValue.vue";
  import AddContractorToProject from "@/components/contractors/AddContractorToProject.vue";
  import Badge from "@/components/common/Badge.vue";
  import BadgeColor from "@/entities/BadgeColor";
  import { emailStatusText } from "@/data/userStatuses";
  import ContractorResendInvitation from "@/components/invite/ContractorResendInvitation.vue";
  import UiButton from "@/components/button/ui-button.vue";
  import InvitationSentTooltip from "@/components/invite/InvitationSentTooltip.vue";
  import { NO_INFORMATION } from "@/data/placeholders";

  @Component({
    components: {
      InvitationSentTooltip,
      UiButton,
      ContractorResendInvitation,
      AddContractorToProject,
      CardItemValue,
      CardItemContainer,
      ManagerChips,
      ItemChipsWithMore,
      CardItemTitle,
      ContractorEmployeeCard,
      CardRating,
      Badge,
    },
  })
  export default class CompanyContractorCard extends Vue {
    @Prop({ type: Object, required: true }) readonly contractor!: Contractor;
    @Prop({ type: Object, required: true }) readonly ratingTotal!: Contractor_Rating_Aggregate;
    @Prop({ type: Object, default: undefined }) readonly contractorDetailsPageRoute!: RouteParams<{id: string}>;
    @Prop({ type: String, required: true }) readonly userUpdatedDate!: string;
    @Prop({ type: String, required: true }) readonly currentUserId!: string;
    @Prop({ type: String, required: true }) readonly companyId!: string;
    @Prop({ type: String, required: true }) readonly currentUserRole!: string;
    @PropSync('nameBlockMinHeight', { type: Number, default: undefined }) nameBlockMinHeightValue?: number;
    @PropSync('skillsBlockMinHeight', { type: Number, default: undefined }) skillsBlockMinHeightValue?: number;
    @Prop({ type: Boolean, required: false, default: false }) readonly isAccessGranted!: boolean;

    BadgeColor = BadgeColor;
    emailStatusText: string = emailStatusText;

    get isEmailUnconfirmed(): boolean {
      return !Boolean(this.contractorUser.confirmed);
    }

    get contractorUser(): User {
      return this.contractor.user;
    }

    get contractorPageRoute(): RouteParams<{id: string}> {
      if (this.contractorDetailsPageRoute) {
        return this.contractorDetailsPageRoute;
      }

      return {
        name: RouteNames.CONTRACTOR_DETAILS_ABOUT,
        params: {
          id: this.contractor.id,
        },
      };
    }
  }
